export default function (): boolean {
  const { $debug } = useNuxtApp();

  try {
    const {
      userHasDocument,
      userHasBirthdate,
      userNationalities,
      isNewUserToValidate,
      userCountry,
      userGender,
      isRegulatoryValidationEnabled,
    } = useUserData();

    const checkDocsRules = computed<boolean>(() => {
      if (userCountry.value !== 'BRA') {
        return true;
      }

      if (isNewUserToValidate.value) {
        if (isBetBr()) {
          const isDocValid =
            userHasDocument.value &&
            userHasBirthdate.value &&
            userNationalities.value.length > 0;

          if (isRegulatoryValidationEnabled.value) {
            return isDocValid && !!userGender.value;
          }

          return isDocValid;
        } else {
          return userHasDocument.value && userHasBirthdate.value;
        }
      }

      return true;
    });

    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ DOCS VALIDATION:\n');
      console.debug('🗺️ ~ userHasDocument:', userHasDocument.value);
      console.debug('🗺️ ~ userHasBirthdate:', userHasBirthdate.value);
      console.debug('🗺️ ~ userNationalities:', userNationalities.value.length);
      console.debug('🗺️ ~ userNationalities:', userNationalities.value);
      console.debug('🗺️ ~ userGender:', userGender.value);
      coloredDebug(checkDocsRules.value);
      console.groupEnd();
    }

    return checkDocsRules.value;
  } catch (err) {
    if ($debug.isEnabled) {
      console.groupCollapsed('🗺️ ~ DOCS VALIDATION:\n');
      console.error(err);
      coloredDebug(false);
      console.groupEnd();
    }

    return false;
  }
}
